export const DEFAULT_NFT_IMAGE = '/alvey-default.svg'
